import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./lib/theme";
import { AdminProvider } from "./lib/admin";
import { HomePage } from "./pages/HomePage";
import { DateDetailPage } from "./pages/DateDetailPage";
import { BlogPage } from "./pages/BlogPage";
import { SupportPage } from "./pages/SupportPage";
import { SupportersPage } from "./pages/SupportersPage";
import { CategoryPage } from "./pages/CategoryPage";
import { AdminLoginPage } from "./pages/AdminLoginPage";
import { AdminDashboardPage } from "./pages/AdminDashboardPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ScrollToHash } from "./components/ScrollToHash";

function App() {
  return (
    <ThemeProvider>
      <AdminProvider>
        <BrowserRouter>
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/date/:id" element={<DateDetailPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/supporters" element={<SupportersPage />} />
            <Route path="/category/:slug" element={<CategoryPage />} />
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </AdminProvider>
    </ThemeProvider>
  );
}

export default App;
